import { normalizeAccountName } from '../../../helpers/normalizeAccountName.ts'

const ACCOUNTS_WITHOUT_PERCENTAGE = ['faturamento']

export const shouldShowAccountPercentage = (accountName: string): boolean =>
  !ACCOUNTS_WITHOUT_PERCENTAGE.includes(normalizeAccountName(accountName))
